import { type FC } from "react";
import { Navigate } from "react-router";

export const DashboardHome: FC = () => {
  return <Navigate to="/dashboard/projects" replace />;
};
